import { useEffect } from "react";
import { Outlet ,Navigate, useLocation} from "react-router-dom"
import { useDispatch } from "react-redux";
import { SideBar } from './Sidebar'
import { Header } from './Header'
import ScrollToTop from '../Utils/ScrollToTop'
import { store } from "../../src/Redux/store";
import Actions from "../Redux/action";

const SESSION_TIMEOUT_POLL_INTERVAL = 2 * 60 * 1000; // 2 minutes

export const Layout = () => {
    const location=useLocation()
    const dispatch = useDispatch();
    let token = store?.getState()?.LOGIN_CREDS?.user?.token

    useEffect(() => {
        if (token) {
            dispatch(Actions.getSessionTimeoutAction());
            const interval = setInterval(() => {
                dispatch(Actions.getSessionTimeoutAction());
            }, SESSION_TIMEOUT_POLL_INTERVAL);
            return () => clearInterval(interval);
        }
    }, [token, dispatch]);

    return (
        <>

            {token ? <div className={"dashboard-main-wrapper"}>
                <ScrollToTop />
                <SideBar />
                <Header />
                <div className={location.pathname === "/schedular" || location?.pathname === '/sections/table' ? "dashboard-wrapper-hide" : "dashboard-wrapper"}>
                    <div className="dashboard-ecommerce">
                        <div className="container-fluid dashboard-content ">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div> : <Navigate to='/' />}
        </>


    )
}